var locale = {
  'login.bell.title': '通知',
  'login.account.title': 'アカウント',
  'login.account.user.id': 'ユーザーID',
  'login.account.user.info': '個人情報',
  logout: 'ログアウト',
  login: '登录'
};
export default locale;